import React, { FormEvent, FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CSVImportTable from '../settings/dataManagement/CSVImportTable';
import { ICSVQuery } from '../../../../services/apis/csv/useCSVimportRequest';
import { useCSVEnrichmentHandlers } from '../../../../services/actions/csv-enrichment/useCSVEnrichmentHandlers';
import Row from '../../../../components/Row';
import TablePageNavigation from '../../../../components/TablePageNavigation';

interface ICSVEnrichmentListProps { }

const CSVEnrichmentList: FunctionComponent<ICSVEnrichmentListProps> = () => {
    const tableRef = useRef<HTMLDivElement>(null);
    const { getEnrichedCSVsHandler } = useCSVEnrichmentHandlers();
    const [ csvEnrichments, setCsvEnrichments ] = useState<any>([]);
    const [ queryParams , setQueryParams ] = useState<ICSVQuery>({page: 1, pageSize: 50});
    const [ metaData, setMetaData ] = useState<any>({
        pages: 1,
        totalCount: 0
    });

    useEffect(() => {
        getCSVEnrichments();
    }, [queryParams]);

    useEffect(() => {
        getCSVEnrichments();
    }, []);

    const getCSVEnrichments = useCallback(async () => {
        const result = await getEnrichedCSVsHandler(queryParams);
        const updatedData = result.data.map((row: any) => ({
            ...row,
            fileUrl: <a href={row.fileUrl}>{row.fileName}</a>
        }));
        setCsvEnrichments(updatedData);
        setMetaData(result.meta);
    }, [queryParams]);

    const [columns, setColumns] = useState<{
        header: string;
        key: string[];
        show: boolean;
        width: string;
        showSmall?: boolean;
        render?: (row: any) => JSX.Element | string;
    }[]>([
        { header: 'Link', key: ['fileUrl', 'name'], show: true, width: '300px', showSmall: true},
        { header: 'Credits used', key: ['creditsUsed'], show: true, width: '10%'},
        { header: 'User', key: ['userEmail'], show: true, width: '350px' },
        { header: 'Date', key: ['createdAtMoment'], show: true, width: '15%' }
    ]);

    return <Container>
        <StyledRow>
            <TablePageNavigation 
                page={queryParams.page} 
                pageSize={queryParams.pageSize} 
                totalCount={metaData.totalCount}
                onPageChanged={(value: number) => setQueryParams({...queryParams, page: value})}
                onPageSizeChanged={(value: number) => setQueryParams({...queryParams, pageSize: value})}
            />
        </StyledRow>
        <CSVImportTable data={csvEnrichments} columns={columns} tableRef={tableRef} setColumns={setColumns} isEnrichment={true}/>
    </Container>
}

const Container = styled.div`
    width: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    overflow-y:auto;
    height: 100%;
`
const StyledRow = styled(Row)`
    justify-content: flex-end;
    width: 100%;
`

export default CSVEnrichmentList; 